import { useState, useEffect } from "react";
import { X, Calendar, Building2, RotateCcw, Check, Filter } from "lucide-react";

import DatePickerPT from "./DatePickerPt";

import "./FiltrosDepositosModal.scss";

const FiltrosDepositosModal = ({
  open,
  onClose,
  filtros,
  setFiltros,
  caixas = [],
  onLimparFiltros,
}) => {
  const [filtrosLocais, setFiltrosLocais] = useState({
    dataInicio: "",
    dataFim: "",
    caixa: "",
    status: "",
    valorMin: "",
    valorMax: "",
  });

  // Sincronizar com filtros externos quando modal abre
  useEffect(() => {
    if (open) {
      setFiltrosLocais({
        dataInicio: filtros.dataInicio || "",
        dataFim: filtros.dataFim || "",
        caixa: filtros.caixa || "",
        status: filtros.status || "",
        valorMin: filtros.valorMin || "",
        valorMax: filtros.valorMax || "",
      });
    }
  }, [open, filtros]);

  if (!open) return null;

  const handleAplicar = () => {
    setFiltros(filtrosLocais);
    onClose();
  };

  const handleLimpar = () => {
    const filtrosVazios = {
      dataInicio: "",
      dataFim: "",
      caixa: "",
      status: "",
      valorMin: "",
      valorMax: "",
      busca: filtros.busca || "", // Manter busca
    };

    setFiltrosLocais(filtrosVazios);
    setFiltros(filtrosVazios);

    if (onLimparFiltros) {
      onLimparFiltros();
    }
  };

  const hoje = new Date().toISOString().split("T")[0];
  const umMesAtras = new Date(Date.now() - 30 * 24 * 60 * 60 * 1000)
    .toISOString()
    .split("T")[0];

  // Filtros rápidos predefinidos
  const aplicarFiltroRapido = (tipo) => {
    const novosFiltros = { ...filtrosLocais };

    switch (tipo) {
      case "hoje":
        novosFiltros.dataInicio = hoje;
        novosFiltros.dataFim = hoje;
        break;
      case "semana":
        const umaSemanaAtras = new Date(Date.now() - 7 * 24 * 60 * 60 * 1000)
          .toISOString()
          .split("T")[0];
        novosFiltros.dataInicio = umaSemanaAtras;
        novosFiltros.dataFim = hoje;
        break;
      case "mes":
        novosFiltros.dataInicio = umMesAtras;
        novosFiltros.dataFim = hoje;
        break;
      case "ativos":
        novosFiltros.status = "ativo";
        break;
      case "cancelados":
        novosFiltros.status = "cancelado";
        break;
      default:
        break;
    }

    setFiltrosLocais(novosFiltros);
  };

  // Contar filtros ativos
  const contarFiltrosAtivos = () => {
    return Object.values(filtrosLocais).filter((valor) => valor !== "").length;
  };

  return (
    <div className="depositoFiltros-modal-overlay">
      <div className="depositoFiltros-modal">
        <div className="depositoFiltros-modal-header">
          <div className="depositoFiltros-modal-header-content">
            <div className="depositoFiltros-modal-title-section">
              <Filter className="depositoFiltros-icon-lg" />
              <div>
                <h2 className="depositoFiltros-modal-title">
                  Filtros Avançados
                </h2>
                <p className="depositoFiltros-modal-subtitle">
                  {contarFiltrosAtivos() > 0
                    ? `${contarFiltrosAtivos()} filtro(s) aplicado(s)`
                    : "Nenhum filtro aplicado"}
                </p>
              </div>
            </div>
            <button onClick={onClose} className="depositoFiltros-modal-close">
              <X className="depositoFiltros-icon" />
            </button>
          </div>
        </div>

        <div className="depositoFiltros-modal-content">
          {/* Filtros Rápidos */}
          <div className="depositoFiltros-section">
            <h3 className="depositoFiltros-section-title">Filtros Rápidos</h3>
            <div className="depositoFiltros-quick-filters">
              <button
                onClick={() => aplicarFiltroRapido("hoje")}
                className="depositoFiltros-quick-btn"
              >
                Hoje
              </button>
              <button
                onClick={() => aplicarFiltroRapido("semana")}
                className="depositoFiltros-quick-btn"
              >
                Última Semana
              </button>
              <button
                onClick={() => aplicarFiltroRapido("mes")}
                className="depositoFiltros-quick-btn"
              >
                Último Mês
              </button>
              <button
                onClick={() => aplicarFiltroRapido("ativos")}
                className="depositoFiltros-quick-btn"
              >
                Só Ativos
              </button>
              <button
                onClick={() => aplicarFiltroRapido("cancelados")}
                className="depositoFiltros-quick-btn"
              >
                Só Cancelados
              </button>
            </div>
          </div>

          {/* Período */}
          <div className="depositoFiltros-section">
            <h3 className="depositoFiltros-section-title">
              <Calendar className="depositoFiltros-icon" />
              Período
            </h3>
            <div className="depositoFiltros-date-grid">
              <div className="depositoFiltros-form-group">
                <label className="depositoFiltros-label">Data Início</label>
                <DatePickerPT
                  value={filtrosLocais.dataInicio}
                  onChange={(value) =>
                    setFiltrosLocais({ ...filtrosLocais, dataInicio: value })
                  }
                  placeholder="Data início"
                />
              </div>
              <div className="depositoFiltros-form-group">
                <label className="depositoFiltros-label">Data Fim</label>
                <DatePickerPT
                  value={filtrosLocais.dataFim}
                  onChange={(value) =>
                    setFiltrosLocais({ ...filtrosLocais, dataFim: value })
                  }
                  placeholder="Data Fim"
                />
              </div>
            </div>
          </div>

          {/* Caixa */}
          <div className="depositoFiltros-section">
            <h3 className="depositoFiltros-section-title">
              <Building2 className="depositoFiltros-icon" />
              Caixa
            </h3>
            <div className="depositoFiltros-form-group">
              <label className="depositoFiltros-label">
                Filtrar por caixa específica
              </label>
              <select
                value={filtrosLocais.caixa}
                onChange={(e) =>
                  setFiltrosLocais({ ...filtrosLocais, caixa: e.target.value })
                }
                className="depositoFiltros-select"
              >
                <option value="">Todas as caixas</option>
                {caixas.map((caixa) => (
                  <option key={caixa._id} value={caixa._id}>
                    {caixa.caixa}
                  </option>
                ))}
              </select>
              <p className="depositoFiltros-help-text">
                Mostra depósitos que envolvem a caixa selecionada (origem ou
                destino)
              </p>
            </div>
          </div>

          {/* Status */}
          <div className="depositoFiltros-section">
            <h3 className="depositoFiltros-section-title">Estado</h3>
            <div className="depositoFiltros-radio-group">
              <label className="depositoFiltros-radio-item">
                <input
                  type="radio"
                  name="status"
                  value=""
                  checked={filtrosLocais.status === ""}
                  onChange={(e) =>
                    setFiltrosLocais({
                      ...filtrosLocais,
                      status: e.target.value,
                    })
                  }
                  className="depositoFiltros-radio"
                />
                <span className="depositoFiltros-radio-label">Todos</span>
              </label>
              <label className="depositoFiltros-radio-item">
                <input
                  type="radio"
                  name="status"
                  value="ativo"
                  checked={filtrosLocais.status === "ativo"}
                  onChange={(e) =>
                    setFiltrosLocais({
                      ...filtrosLocais,
                      status: e.target.value,
                    })
                  }
                  className="depositoFiltros-radio"
                />
                <span className="depositoFiltros-radio-label">
                  Apenas Ativos
                </span>
              </label>
              <label className="depositoFiltros-radio-item">
                <input
                  type="radio"
                  name="status"
                  value="cancelado"
                  checked={filtrosLocais.status === "cancelado"}
                  onChange={(e) =>
                    setFiltrosLocais({
                      ...filtrosLocais,
                      status: e.target.value,
                    })
                  }
                  className="depositoFiltros-radio"
                />
                <span className="depositoFiltros-radio-label">
                  Apenas Cancelados
                </span>
              </label>
            </div>
          </div>

          {/* Valor */}
          <div className="depositoFiltros-section">
            <h3 className="depositoFiltros-section-title">Valor</h3>
            <div className="depositoFiltros-value-grid">
              <div className="depositoFiltros-form-group">
                <label className="depositoFiltros-label">
                  Valor Mínimo (CVE)
                </label>
                <input
                  type="number"
                  step="0.01"
                  min="0"
                  value={filtrosLocais.valorMin}
                  onChange={(e) =>
                    setFiltrosLocais({
                      ...filtrosLocais,
                      valorMin: e.target.value,
                    })
                  }
                  className="depositoFiltros-input"
                  placeholder="0.00"
                />
              </div>
              <div className="depositoFiltros-form-group">
                <label className="depositoFiltros-label">
                  Valor Máximo (CVE)
                </label>
                <input
                  type="number"
                  step="0.01"
                  min={filtrosLocais.valorMin || "0"}
                  value={filtrosLocais.valorMax}
                  onChange={(e) =>
                    setFiltrosLocais({
                      ...filtrosLocais,
                      valorMax: e.target.value,
                    })
                  }
                  className="depositoFiltros-input"
                  placeholder="0.00"
                />
              </div>
            </div>
          </div>
        </div>

        <div className="depositoFiltros-modal-actions">
          <button
            onClick={handleLimpar}
            className="depositoFiltros-btn depositoFiltros-btn-outline"
          >
            <RotateCcw className="depositoFiltros-icon" />
            Limpar Tudo
          </button>
          <button
            onClick={onClose}
            className="depositoFiltros-btn depositoFiltros-btn-secondary"
          >
            Cancelar
          </button>
          <button
            onClick={handleAplicar}
            className="depositoFiltros-btn depositoFiltros-btn-primary"
          >
            <Check className="depositoFiltros-icon" />
            Aplicar Filtros
          </button>
        </div>
      </div>
    </div>
  );
};

export default FiltrosDepositosModal;
